import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #3A3580, #1C1A5E)',
      padding: '2.5rem 0',
      textAlign: 'center',
    }}>
      <div className="content-column">
        <div style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.25rem',
          color: '#fff',
          marginBottom: '0.5rem',
        }}>
          She'll Be Right Assistance
        </div>
        <div style={{
          fontSize: '0.83rem',
          color: '#A8A0D0',
          marginBottom: '0.6rem',
        }}>
          Sumner · Redcliffs · Mt Pleasant · Ferrymead — further afield by arrangement
        </div>
        <div style={{
          fontSize: '0.78rem',
          color: '#7A70B0',
          fontStyle: 'italic',
        }}>
          Made with care in the neighbourhood
        </div>
      </div>
    </footer>
  );
}
